import { useSession } from "./context/SessionContext";

// Permissões por papel no sistema web. A API confere de novo (semComercial); aqui é só o que aparece.
// O Comercial de parceiros usa Parceiros, Simulador (com reserva interna) e o Estoque só para consulta.
// Admin e os outros papéis veem tudo.

const ROTAS_DO_COMERCIAL = ["/estoque", "/simulador", "/parceiros"];

export const ehComercial = (papel: string | undefined) => papel === "comercial_parceiros";

/** A rota (ou o item do menu) aparece para esse papel? */
export const podeVerRota = (papel: string | undefined, rota: string) =>
  !ehComercial(papel) || ROTAS_DO_COMERCIAL.some((r) => rota === r || rota.startsWith(`${r}/`));

/** Permissões do usuário logado. `gerenciaEstoque`: importar, pausar, desativar/ativar carta. */
export function usePermissoes() {
  const papel = useSession().usuario?.papel;
  const comercial = ehComercial(papel);
  return {
    papel,
    podeVerRota: (rota: string) => podeVerRota(papel, rota),
    gerenciaEstoque: !comercial,
    veReservas: !comercial,
  };
}
